import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-5d5bc314"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: "Locates"
}, null, -1))
const _hoisted_2 = { class: "menu-container" }
const _hoisted_3 = { class: "navbar navbar-expand-lg navbar-expand-md" }
const _hoisted_4 = { class: "menu navbar-nav" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-compass icon-menu-item" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-none d-lg-inline d-md-inline" }, "Marketplace", -1))
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-grid icon-menu-item" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-none d-lg-inline d-md-inline" }, "Meu Painel", -1))
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-send icon-menu-item" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-none d-lg-inline d-md-inline" }, "Enviar", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "nav-link disabled disabled-spacing" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-database icon-menu-item-disabled" }),
    /*#__PURE__*/_createElementVNode("label", { class: "d-none d-lg-inline d-md-inline" }, "Locates Labs")
  ])
], -1))
const _hoisted_15 = { class: "icon-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createVNode(_component_router_link, { to: "/my-panel" }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("ol", _hoisted_4, [
          _createElementVNode("li", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/marketplace",
              class: _normalizeClass([{ active: _ctx.$route.path === '/marketplace' }, "nav-link"])
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _hoisted_7
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createVNode(_component_router_link, {
              to: "/my-panel",
              class: _normalizeClass([{ active: _ctx.$route.path === '/my-panel' }, "nav-link"])
            }, {
              default: _withCtx(() => [
                _hoisted_9,
                _hoisted_10
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("li", _hoisted_11, [
            _createVNode(_component_router_link, {
              to: "/send",
              class: _normalizeClass([{ active: _ctx.$route.path === '/send' }, "nav-link"])
            }, {
              default: _withCtx(() => [
                _hoisted_12,
                _hoisted_13
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _hoisted_14
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("i", {
        class: "bi bi-box-arrow-right",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logout())),
        "data-bs-toggle": "tooltip",
        "data-bs-placement": "top",
        title: "Sair"
      })
    ])
  ]))
}